import React, { useEffect, useRef, useState } from "react";
import FormStrip from "../../components/FormStrip";
import { useTranslation } from "react-i18next";
import {
  MainWrapper,
  PrimaryTab,
  PrimaryTabs,
  PrimaryTabsWrapper,
  StyledDivider,
  SubTab,
  SubTabs,
  SubTabsWrapper,
} from "../../components/StyledComponent";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import { BackButton, Loader, Toast } from "@egovernments/digit-ui-react-components";
import SubStep1 from "./Step1/SubStep1";
import getMapSubmissionData from "../map-submission/getMapSubmissionData";
import SubStep2 from "./Step1/SubStep2";
import SubStep3 from "./Step1/SubStep3";
import Step6 from "../map-submission/Step6";
import ReactToPrint from "react-to-print";
import SubStep4 from "./Step1/SubStep4";
import Step2 from "./Step2";
import Step3 from "./Step3";
import SearchSummary from "../map-submission/Summary/SearchSummary";
import { Card } from "@mui/material";
import ButtonWrapper from "../../components/Button";
import { useHistory } from "react-router-dom";
import Step4 from "./Step4";
import NOCTakeAction from "@egovernments/digit-ui-module-common/src/sharedComponents/NOCTakeAction";
import IdentifyNoc from "../../reusableComponents/IdentifyNoc";

const PurchasableFARV3 = () => {
  const dispatch = useDispatch();
  const { initFormMTDocs, resetFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const [iframeSrc, setIframeSrc] = useState("");
  const { t } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const { id } = useParams();
  const [selectedSubTab, setSelectedSubTab] = useState(Digit?.SessionStorage.get("SA_CURRENT_SUBTAB") || 0);
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("SA_CURRENT_TAB") || 0);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [summaryShow, setSummaryshow] = useState(Digit?.SessionStorage.get("SUMMARYSA_TAB") || false);
  const history = useHistory();
  const { applicationData, isAppDataLoading } = getMapSubmissionData(t, id);
  const { info: userInfo } = Digit.UserService.getUser();
  const userType = userInfo?.info?.type;
  const isEmployee = userType === "EMPLOYEE";
  const Modal = useModal();
  const componentRef = useRef();
  const subTabLabels = [
    { label: "Application Information" },
    { label: "Plot Details" },
    { label: "Applicant Information" },
    { label: "Geo Location" },
    { label: "NOC Status" },
  ];
  const closeToast = () => {
    setShowToast(null);
  };
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_PURCHASABLE_FAR", applicationData || {});

  const {
    data: { LandUseMasterData: { Authorities: schemeTypeData } = {} } = {},
    isLoading: schemeTypeDataLoading,
  } = Digit.Hooks.obps.useMDMS(tenantId, "LandUseMasterData", ["Authorities"]);
  const {
    data: { PrimaryUseMasterData: { ProposedActivity: nonSchemeTypeData } = {} } = {},
    isLoading: nonSchemeTypeDataLoading,
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);

  useEffect(() => {
    Digit.SessionStorage.get("FILE_NO");
    Digit.SessionStorage.get("OWNER_INFO");
  }, []);
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);

  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      console.log(data, "updatedDatahere");

      setParams({ ...data });
    } else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);

  const handleSubTabChange = (nextSubTab, formData = null) => {
    if (formData) {
      const data = { ...params, ...formData };
      data.applicationType = "FORM_PURCHASABLE_FAR";
      data.planOn = "PURCHASABLE_MAP";
      if (data?.additionalDetails) {
        delete data.additionalDetails;
      }
      if (activeTab === 0 && selectedSubTab === 0 && !id) {
        delete data.applicationNo;
        if (!data.workflow) {
          data.workflow = {};
        }
        data.workflow.action = "INITIATE";
        Digit.OBPSService.create({ BPA: data }, tenantId)
          .then((res) => {
            if (res?.BPA?.length > 0) {
              onSelect("", { ...data, ...res.BPA[0] }, true);
              setShowToast({
                error: false,
                message: `Application Created Successfully!`,
              });
              setSelectedSubTab(nextSubTab);
              Digit.SessionStorage.set("SA_CURRENT_SUBTAB", nextSubTab);
            }
          })
          .catch((e) => {
            Modal("Error", `${e?.response?.data?.Errors[0]?.message}`, "error");
          });
      } else {
        try {
          data.workflow = { action: "UPLOAD_DOC", assignes: null };
          updateApiCall.mutate(
            { BPA: data },
            {
              onSuccess: (res) => {
                onSelect("", res?.BPA?.[0]);
                setShowToast({ error: false, message: `Data has been saved successfully` });
                setSelectedSubTab(nextSubTab);
                Digit.SessionStorage.set("SA_CURRENT_SUBTAB", nextSubTab);
              },
              onError: () => {
                Modal("Update Error", "Something went wrong!!", "error");
              },
            }
          );
        } catch (error) {
          console.error(error);
          Modal("Update Error", "Something went wrong!!", "error");
        }
      }
    } else {
      setSelectedSubTab(nextSubTab);
      Digit.SessionStorage.set("SA_CURRENT_SUBTAB", nextSubTab);
    }
  };
  const handleDeclarationChange = (event) => {
    setDeclarationChecked(event.target.checked);
  };
  const { data: { BPA: { StandardBuildingDesigns: standardDesigns } = {} } = {}, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(
    tenantId,
    "BPA",
    ["StandardBuildingDesigns"]
  );
  const handleTabChange = async (nextTabNo, formData = null) => {
    if (formData) {
      const data = { ...params, ...formData };
      const isSelfCert =
        params?.planOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
        params?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
      try {
        // if (nextTabNo === 4 && params?.status !== "REVERT_TO_APPLICANT") {
        //   data.workflow = { action: isSelfCert ? "MAKE_PAYMENT_SELF" : "MAKE_PAYMENT", assignes: null };
        // }
        if (nextTabNo === 4) {
          data.workflow = { action: "FORWARD_TO_DEPARTMENT", assignes: null };
        } else {
          data.workflow = { action: "UPLOAD_DOC", assignes: null };
        }
        updateApiCall.mutate(
          { BPA: data },
          {
            onSuccess: (res) => {
              onSelect("", { ...data, ...res?.BPA?.[0] });
              if (nextTabNo === 4) {
                Modal(
                  "Application Submited",
                  `Your Application ${params?.applicationNo} has been sent to department for further approval`,
                  "success"
                );
                clearParams();
                Digit.SessionStorage.del("FORM_SELF_APPROVAL");
                Digit?.SessionStorage.del("EDCR_CREATE");
                Digit?.SessionStorage.del("FASTPAS_ID");
                Digit?.SessionStorage.del("SUMMARYSA_TAB");
                setTimeout(() => {
                  resetFormMTDocs();
                }, 0);
                Digit.SessionStorage.del("SA_CURRENT_TAB");
                Digit.SessionStorage.del("SA_CURRENT_SUBTAB");
              } else {
                if (nextTabNo === 3) {
                  Digit.SessionStorage.set("SUMMARYSA_TAB", true);
                  setSummaryshow(true);
                }
                setShowToast({ error: false, message: `Data has been saved successfully` });
                setActiveTab(nextTabNo);
                Digit.SessionStorage.set("SA_CURRENT_TAB", nextTabNo);
              }
            },
            onError: () => {
              Modal("Update Error", "Something went wrong!!", "error");
            },
          }
        );
      } catch (error) {
        console.error(error);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    }
    if (nextTabNo === 3) {
      Digit.SessionStorage.set("SUMMARY_TAB", true);
      setSummaryshow(true);
    }
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("SA_CURRENT_TAB", nextTabNo);
  };

  useEffect(() => {
    if (id && applicationData) {
      setParams(applicationData);
      if (applicationData?.documents?.length > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, applicationData]);

  const renderContent = () => {
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return (
            <SubStep1
              formData={params}
              handleSubTabChange={handleSubTabChange}
              userInfo={userInfo}
              schemeTypeData={schemeTypeData}
              nonSchemeTypeData={nonSchemeTypeData}
              id={id}
              onSelect={onSelect}
              initFormMTDocs={initFormMTDocs}
              standardDesigns={standardDesigns}
            />
          );
        case 1:
          return <SubStep2 formData={params} handleSubTabChange={handleSubTabChange} isEmployee={isEmployee} />;
        case 2:
          return <SubStep3 formData={params} handleSubTabChange={handleSubTabChange} isEmployee={isEmployee} />;
        case 3:
          return (
            <SubStep4
              formData={params}
              handleSubTabChange={handleSubTabChange}
              isEmployee={isEmployee}
              iframeSrc={iframeSrc}
              setIframeSrc={setIframeSrc}
            />
          );
        case 4:
          return (
            <React.Fragment>
              {params?.nocList?.length > 0 ? (
                <NOCTakeAction formData={params} />
              ) : (
                <IdentifyNoc
                  formData={params}
                  tenantId={tenantId}
                  handleTabChange={handleTabChange}
                  handleSubTabChange={handleSubTabChange}
                  isEmployee={isEmployee}
                />
              )}
            </React.Fragment>
          );
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return <Step2 formData={params} handleTabChange={handleTabChange} tenantId={tenantId} isEmployee={isEmployee} />;
    } else if (activeTab === 2) {
      return <Step4 formData={params} handleTabChange={handleTabChange} tenantId={tenantId} isEmployee={isEmployee} />;
    }
    //  else if (activeTab === 3) {
    //   return <Step3 formData={params} handleTabChange={handleTabChange} isEmployee={isEmployee} />;
    // }
    else if (activeTab === 3 && summaryShow && params?.applicationNo) {
      return (
        <div>
          <Card style={{ width: "90%", margin: "0 auto" }} ref={componentRef}>
            <SearchSummary
              id={params?.applicationNo}
              ref={componentRef}
              handleDeclarationChange={handleDeclarationChange}
              declarationChecked={declarationChecked}
              showDeclaration={true}
            />
            <div
              style={{
                margin: "20px",
                padding: "12px 16px",
                backgroundColor: "#fff3cd",
                border: "1px solid #ffeeba",
                borderRadius: "4px",
                color: "#856404",
                fontWeight: "500",
              }}
            >
              {t("FASTPAS.GLOBAL.ONCE.TEXT")}
            </div>
          </Card>
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ReactToPrint
                trigger={() => (
                  <ButtonWrapper variant="contained" color="success" size="medium" label="Print" sx={{ backgroundColor: "#7600bc" }}>
                    Print Summary
                  </ButtonWrapper>
                )}
                content={() => componentRef.current}
              />
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Preview"
                sx={{ backgroundColor: "#CCC" }}
                onClick={() => handleTabChange(0)}
              />
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label={"Forward to Department"}
                type="submit"
                sx={{ backgroundColor: "#157CB3", width: "180px" }}
                onClick={() => handleTabChange(4, params)}
                disabled={!declarationChecked}
              />
            </div>
          </div>
        </div>
      );
    } else if (activeTab === 4) {
      return <Step6 formData={params} handleSubTabChange={handleTabChange} />;
    }
  };

  if (isAppDataLoading || (id && !applicationData)) {
    return <Loader />;
  }

  return (
    <MainWrapper>
      <BackButton />
      <FormStrip formName={t("Purchasable FAR")} />
      <PrimaryTabsWrapper className="technical-profession-section">
        {/* Tabs Header */}
        <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="scrollable" scrollButtons="auto">
          <PrimaryTab label="Application Form" />
          <PrimaryTab label="Document" />
          <PrimaryTab label="Drawing" />
          {/* <PrimaryTab label="Fees" /> */}
          <PrimaryTab label="Summary" />
          <PrimaryTab label="Application History" />
        </PrimaryTabs>
      </PrimaryTabsWrapper>
      <StyledDivider />
      {activeTab === 0 && (
        <SubTabsWrapper>
          <SubTabs
            value={selectedSubTab}
            onChange={(e, i) => handleSubTabChange(i)}
            aria-label="Sub Tab Group"
            variant="scrollable"
            scrollButtons="auto"
          >
            {subTabLabels.map((tab, index) => (
              <SubTab key={index} label={tab.label} />
            ))}
          </SubTabs>
        </SubTabsWrapper>
      )}
      {renderContent()}
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </MainWrapper>
  );
};

export default PurchasableFARV3;
